import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Collapse, Input, Label } from "reactstrap";
const DatePosted = ({ onFilterChange, handleClearFilter, searchParams }) => {
  const [toggleFourth, setToggleFourth] = useState(false);
  const [checked, setChecked] = useState([]);

  // Read current filter from URL
  const dateFilter = searchParams.get("DateFilter");

  useEffect(() => {
    if (dateFilter) {
      setChecked([dateFilter]);
    } else {
      setChecked([]);
    }
  }, [dateFilter]);

  const handleToggle = (value) => {
    window.scrollTo({
      top: 250,
      behavior: "smooth",
    });

    setChecked([value]);
    onFilterChange("DateFilter", value);
  };

  return (
    <div className="accordion-item border rounded-3 shadow-sm overflow-hidden mt-3">
      <h2 className="accordion-header" id="datePosted">
        <Button
          className={`accordion-button fw-bold bg-white text-dark py-3 px-4 shadow-none d-flex justify-content-between align-items-center ${
            toggleFourth ? "" : "collapsed"
          }`}
          onClick={(e) => {
            e.preventDefault();
            setToggleFourth(!toggleFourth);
          }}
          role="button"
        >
          <span>Sort Latest</span>

          {checked.length > 0 && (
            <span className="badge bg-soft-primary text-primary rounded-pill fs-12 px-2 py-1 me-3">
              {checked.length} Selected
            </span>
          )}
        </Button>
      </h2>

      <Collapse isOpen={toggleFourth}>
        <div className="accordion-body bg-white p-4 pt-2">
          <div className="side-title form-check-all">
            {/* All Time */}

            <div className="form-check d-flex align-items-center py-1 rounded transition-all">
              <Input
                className="form-check-input cursor-pointer"
                type="checkbox"
                id="date-all"
                checked={!dateFilter}
                onChange={() => {
                  setChecked([]);
                  handleClearFilter("DateFilter");
                }}
              />

              <Label
                className={`form-check-label ms-2 cursor-pointer w-100 ${
                  !dateFilter ? "text-dark fw-semibold" : "text-muted"
                }`}
                htmlFor="date-all"
              >
                All Time
              </Label>
            </div>

            {/* Last Hour */}

            <div className="form-check d-flex align-items-center py-1 mt-2 rounded transition-all">
              <Input
                className="form-check-input cursor-pointer"
                type="checkbox"
                id="date-1hour"
                checked={checked.includes("1hour")}
                onChange={() => handleToggle("1hour")}
              />

              <Label
                className={`form-check-label ms-2 cursor-pointer w-100 ${
                  checked.includes("1hour")
                    ? "text-dark fw-semibold"
                    : "text-muted"
                }`}
                htmlFor="date-1hour"
              >
                Last Hour
              </Label>
            </div>

            {/* Last 24 Hours */}

            <div className="form-check d-flex align-items-center py-1 mt-2 rounded transition-all">
              <Input
                className="form-check-input cursor-pointer"
                type="checkbox"
                id="date-24hours"
                checked={checked.includes("24hours")}
                onChange={() => handleToggle("24hours")}
              />

              <Label
                className={`form-check-label ms-2 cursor-pointer w-100 ${
                  checked.includes("24hours")
                    ? "text-dark fw-semibold"
                    : "text-muted"
                }`}
                htmlFor="date-24hours"
              >
                Last 24 Hours
              </Label>
            </div>

            {/* Last 7 Days */}

            <div className="form-check d-flex align-items-center py-1 mt-2 rounded transition-all">
              <Input
                className="form-check-input cursor-pointer"
                type="checkbox"
                id="date-7days"
                checked={checked.includes("7days")}
                onChange={() => handleToggle("7days")}
              />

              <Label
                className={`form-check-label ms-2 cursor-pointer w-100 ${
                  checked.includes("7days")
                    ? "text-dark fw-semibold"
                    : "text-muted"
                }`}
                htmlFor="date-7days"
              >
                Last 7 Days
              </Label>
            </div>

            {/* Last 14 Days */}

            <div className="form-check d-flex align-items-center py-1 mt-2 rounded transition-all">
              <Input
                className="form-check-input cursor-pointer"
                type="checkbox"
                id="date-14days"
                checked={checked.includes("14days")}
                onChange={() => handleToggle("14days")}
              />

              <Label
                className={`form-check-label ms-2 cursor-pointer w-100 ${
                  checked.includes("14days")
                    ? "text-dark fw-semibold"
                    : "text-muted"
                }`}
                htmlFor="date-14days"
              >
                Last 14 Days
              </Label>
            </div>

            {/* Last 30 Days */}

            <div className="form-check d-flex align-items-center py-1 mt-2 rounded transition-all">
              <Input
                className="form-check-input cursor-pointer"
                type="checkbox"
                id="date-30days"
                checked={checked.includes("30days")}
                onChange={() => handleToggle("30days")}
              />

              <Label
                className={`form-check-label ms-2 cursor-pointer w-100 ${
                  checked.includes("30days")
                    ? "text-dark fw-semibold"
                    : "text-muted"
                }`}
                htmlFor="date-30days"
              >
                Last 30 Days
              </Label>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default DatePosted;
